import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=13617176&"
import script from "./AdditionalFields.vue?vue&type=script&lang=js&"
export * from "./AdditionalFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13617176')) {
      api.createRecord('13617176', component.options)
    } else {
      api.reload('13617176', component.options)
    }
    module.hot.accept("./AdditionalFields.vue?vue&type=template&id=13617176&", function () {
      api.rerender('13617176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/AdditionalFields.vue"
export default component.exports